(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ft-language-picker')) {
    customElements.define('ft-language-picker', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const details = this.querySelector('details');
        const summary = details.querySelector('summary');
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && details.open) {
            event.preventDefault();
            event.stopPropagation();
            details.open = false;
            summary.focus();
          }
        }, { signal });
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) details.open = false;
        }, { signal });

      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
